import { render, staticRenderFns } from "./SecurityRanking.html?vue&type=template&id=54f9e28e&scoped=true&"
import script from "./SecurityRanking.js?vue&type=script&lang=js&"
export * from "./SecurityRanking.js?vue&type=script&lang=js&"
import style0 from "./SecurityRanking.scss?vue&type=style&index=0&id=54f9e28e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9e28e",
  null
  
)

export default component.exports